import { useQuery, useQueryClient } from "@tanstack/react-query";
import { StringifiableRecord } from "query-string";

import { ExecuteData, useApi } from "../../useApi";

import {
  IGetInvoicesResponse,
  IUseGetInvoicesProps
} from "./useGetInvoices.types";

import { useAuth } from "@/core/libs/use-auth";

const INVOICES_QUERY_TOKEN = "invoices";

export const useGetInvoices = ({ params }: IUseGetInvoicesProps) => {
  const { execute } = useApi();
  const { isAuthenticated } = useAuth();
  const invoicesQueryClient = useQueryClient();

  const paramValues = {
    ...params
  };

  interface ApiResponse {
    data: IGetInvoicesResponse;
  }

  const fetchData = (params: StringifiableRecord): Promise<ApiResponse> => {
    const data: ExecuteData = {
      params,
      url: "invoices",
      messages: {
        error: "Tivemos um problema ao carregar as faturas"
      }
    };

    return execute(data) as Promise<ApiResponse>;
  };

  const { data, isFetching, error, isError } = useQuery<ApiResponse, Error>({
    queryKey: [INVOICES_QUERY_TOKEN, paramValues],
    queryFn: () => fetchData(paramValues),
    enabled: isAuthenticated && !!params?.document,
    staleTime: 120000,
    keepPreviousData: true,
    retry: 5
  });

  const invalidateQuery = () => {
    invoicesQueryClient.invalidateQueries({ queryKey: [INVOICES_QUERY_TOKEN] });
  };

  return {
    invoicesList: data?.data?.invoices,
    accountData: data?.data?.account,
    isLoadingInvoices: isFetching,
    isError,
    error,
    invalidateQuery
  };
};
